// extracted by mini-css-extract-plugin
module.exports = {"legalFooter":"bz_hh","grid":"bz_b2","copyright":"bz_hj","actions":"bz_hk","rrss":"bz_hl","links":"bz_hm","link":"bz_d","languageSelector":"bz_hn","legalFooterDark":"bz_hp"};